import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import firebase from "firebase/app";
import "firebase/analytics";

export function AnalyticsTracker({ analytics }) {
    const location = useLocation();

    useEffect(() => {
        if (firebase.analytics) {
            firebase.analytics().logEvent("page_view", { page_path: location.pathname });
        }
    }, [analytics, location]);

    return null;
}
